import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ntc-permissao-negada',
  templateUrl: './permissao-negada.component.html',
  styleUrls: ['./permissao-negada.component.css']
})
export class PermissaoNegadaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/permissao-negada/permissao-negada.component.ts